import React, { Component } from "react";
import Pad from "../Pad";
import "../../Styles/Infinity/Infinity.css";

const KEY_WORDS = ["HIGHER", "LOWER", "INSERT A INCREASE RATE", "START GUESSING!"];

let randomNumber = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export default class Infinity extends Component {
  constructor(props) {
    super(props);
    this.increaseRate = 0;
    this.currentMax = 0;
    this.currentStep = 1;
    this.Max = 0;
    this.Guess = 0;
    this.TimeSpent = 0;
    this.Attempts = 0;
    this.results = []
  }
  onEnter = (PadC, number) => {
    if (PadC.lastCheck === KEY_WORDS[2]) {
      this.setIncreaseRate(PadC, number)
    } else {
      this.checkNumber(PadC, number);
    }
  };
  setIncreaseRate = (PadC, increaseRate) => {
    this.increaseRate = increaseRate
    this.currentMax = increaseRate;
    this.startSession(PadC, this.currentMax);
  }
  startSession = (PadC, max) => {
    PadC.lastCheck = KEY_WORDS[3];
    PadC.Info = `Number Between 0 - ${max}`;
    PadC.Guess = randomNumber(0, max);
    PadC.setState({ input: KEY_WORDS[3] });
    this.Max = max;
    this.Guess = PadC.Guess;
    this.TimeSpent = new Date().getTime();
    this.Attempts = 0;
  };
  checkNumber = (PadC, number) => {
    let newState;
    this.Attempts = this.Attempts + 1;
    if (number > PadC.Guess) {
      newState = KEY_WORDS[1];
    } else if (number < PadC.Guess) {
      newState = KEY_WORDS[0];
    } else if (number === PadC.Guess) {
      this.onGuessed(PadC);
      newState = KEY_WORDS[3];
    }
    PadC.lastCheck = newState;
    PadC.setState({ input: newState });
  };
  onGuessed = (PadC) => {
    this.TimeSpent = new Date().getTime() - this.TimeSpent;
    this.results.push([
      this.currentStep,
      this.Max,
      this.Guess,
      this.TimeSpent,
      this.Attempts,
    ])
    this.Max = 0;
    this.Guess = 0;
    this.TimeSpent = 0;
    this.Attempts = 0;
    this.currentStep++;
    this.currentMax += this.increaseRate;
    this.startSession(PadC, this.currentMax);
  };
  returnLogs = () => {
    if (this.results.length !== 0) {
      let infinityLogsWindow = window.open("");
      let stringToAdd = "<div style='width:100%;display:flex;align-items:center;justify-content:center'>"
      for (var i = 0; i < this.results.length; i++) {
        stringToAdd += `
            <div style='width:200px; text-align:center;'>
                <p>Step Count: ${this.results[i][0]}</p>
                <p>Maximum: ${this.results[i][1]}</p>
                <p>Guessed Number: ${this.results[i][2]}</p>
                <p>Time Spent: ${this.results[i][3]}ms</p>
                <p>Attempts: ${this.results[i][4]}</p>
            </div>
            <br/>
        `
      }
      stringToAdd += "</div>"
      infinityLogsWindow.document.write(stringToAdd)
    }
  }
  render() {
    return (
      <div className="Infinity">
        <Pad INPUT="INSERT A INCREASE RATE" Mode="Infinity" onEnter={this.onEnter} />
        <div onClick={this.returnLogs} className="Options animate__animated animate__slideInRight InfinityLogsButton"><div><p>RETURN LOGS</p></div></div>
      </div>
    );
  }
}
